<template>
	<div class="o-dashboard">

		<div class="o-dashboard__breadcrumbs">
			<c-breadcrumbs></c-breadcrumbs>
		</div>

		<div class="o-dashboard__panels">
			<div class="row collapse">

				<div class="column small-12 xlarge-8">
					<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">

						<h4 class="margin-b-32">{{user.name}}</h4>

						<c-splitbutton class="margin-b-24" :buttons="buttons"></c-splitbutton>

						<div class="row margin-b-16 fs-xsmall">
							<div class="columns small-12 medium-4">
								<span class="color-gray-600 font-heading">E-mailadres</span>
							</div>
							<div class="columns small-12 medium-8">
								{{user.email}}
							</div>
						</div>
						<div class="row margin-b-16 fs-xsmall" v-for="role in user.roles" :key="role.id">
							<div class="columns small-12 medium-4">
								<span class="color-gray-600 font-heading">Rol</span>
							</div>
							<div class="columns small-12 medium-8">
								{{role.name}}
							</div>
						</div>
						<div class="row margin-b-16 fs-xsmall">
							<div class="columns small-12 medium-4">
								<span class="color-gray-600 font-heading">Twee Factor Authenticatie</span>
							</div>
							<div class="columns small-12 medium-8">
								Actief
							</div>
						</div>

					</div>
				</div>

			</div>
		</div>

	</div>

	<c-edit-user-settings
		v-show="modalEditUserSettings"
		@close="modalEditUserSettings = false"
		:size="'medium'">
	</c-edit-user-settings>

</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import CBreadcrumbs from '@components/Breadcrumbs';
import CSplitbutton from '@components/Splitbutton';
import CEditUserSettings from '@app/modals/EditUserSettings';

import { mapGetters } from 'vuex';

export default {
	mixins: [ View, Form ],
	components: {
		CBreadcrumbs, CSplitbutton, CEditUserSettings
	},
	data() {
		return {
			modalEditUserSettings: false
		}
	},
	methods: {
		openModalEditUserSettings() {
			this.modalEditUserSettings = true;
		}
	},
	computed: {
		buttons() {

			const buttons = [{
				label: 'Bewerken',
				action: () => {
					this.openModalEditUserSettings();
				}
			}];

			return buttons;
		},
		...mapGetters({
			user: 'user/get'
		})
	},
	created() {
		this.$store.dispatch('listener/on', {
			listener: this.openModalEditUserSettings,
			event: 'change-user',

		});
	},
	beforeUnmount() {
		this.$store.dispatch('listener/on', {
			listener: this.openModalEditUserSettings,
			event: 'change-user',
		});
	},

}
</script>
